export enum AnalyticsEventName {
  // Auth events
  USER_SIGNED_IN = 'user_signed_in',
  USER_SIGNED_OUT = 'user_signed_out',

  // Home events
  HOME_ARRIVED = 'home_arrived',
  HOME_STORE_SWITCHED = 'home_store_switched',
  STORE_TIMEZONE_PROMPTED = 'store_timezone_prompted',
  STORE_TIMEZONE_DISMISSED = 'store_timezone_dismissed',
  STORE_TIMEZONE_SET = 'store_timezone_set',
  SUGGESTED_ACTION_TASK_CREATED_FOR_TODAY = 'suggested_action_task_created_for_today',
  SUGGESTED_ACTION_TASK_CREATED_FOR_LATER = 'suggested_action_task_created_for_later',
  SUGGESTED_ACTION_NEWSFEED_POSTED = 'suggested_action_newsfeed_posted',
  SUGGESTED_ACTION_NEWSFEED_EDITED = 'suggested_action_newsfeed_edited',
  SUGGESTED_ACTION_LEARNING_ASSIGNED = 'suggested_action_learning_assigned',
  SUGGESTED_ACTION_DISMISSED = 'suggested_action_dismissed',

  // Briefing events
  BRIEFING_VIEWED = 'briefing_viewed',
  BRIEFING_DISMISSED = 'briefing_dismissed',

  // Home tasks events
  HOME_TASK_CHECKED = 'home_task_checked',
  HOME_TASK_UNCHECKED = 'home_task_unchecked',
  HOME_TASK_EDITED = 'home_task_edited',
  HOME_TASK_POSTPONED = 'home_task_postponed',
  HOME_TASK_DELETED_UNCHECKED = 'home_task_deleted_unchecked',
  HOME_TASK_DELETED_CHECKED = 'home_task_deleted_checked',

  // Tasks events
  TASK_FILTER_CHANGED = 'task_filter_changed',
  TASK_SCOPE_CHANGED = 'task_scope_changed',
  TASK_CREATED = 'task_created',
  TASK_CHECKED = 'task_checked',
  TASK_UNCHECKED = 'task_unchecked',
  TASK_EDITED = 'task_edited',
  TASK_DELETED_UNCHECKED = 'task_deleted_unchecked',
  TASK_DELETED_CHECKED = 'task_deleted_checked',
  TASK_COMPLETED_EARLIER_SHOWN = 'task_completed_earlier_shown',
  TASK_OPENED = 'task_opened',
  TASK_ITEM_CHECKED = 'task_item_checked',
  TASK_ITEM_UNCHECKED = 'task_item_unchecked',

  // Handover events
  HANDOVER_DRAFT_OPENED = 'handover_draft_opened',
  HANDOVER_BLOCK_TOGGLED = 'handover_block_toggled',
  HANDOVER_NOTE_ADDED = 'handover_note_added',
  HANDOVER_SENT = 'handover_sent',
  HANDOVER_VIEWED = 'handover_viewed',
  HANDOVER_CONFIRMED = 'handover_confirmed',
  HANDOVER_HISTORY_OPENED = 'handover_history_opened',
  HANDOVER_FOLLOW_UP_MARKED = 'handover_follow_up_marked',
  HANDOVER_FOLLOW_UP_TICKED = 'handover_follow_up_ticked',
  HANDOVER_TEMPLATE_ANSWERED = 'handover_template_answered',
  HANDOVER_BLOCK_SETTINGS_SAVED = 'handover_block_settings_saved',
  HANDOVER_TEMPLATE_SAVED = 'handover_template_saved',
  HANDOVER_TEMPLATE_DELETED = 'handover_template_deleted',

  // Shift fill events
  SHIFT_FILL_REQUEST_CREATED = 'shift_fill_request_created',
  SHIFT_FILL_REQUEST_CANCELLED = 'shift_fill_request_cancelled',

  // Academy events
  ACADEMY_OPENED = 'academy_opened',

  // Newsfeed events
  NEWSFEED_ARRIVED = 'newsfeed_arrived',
  NEWSFEED_UNREAD_FILTER_CHANGED = 'newsfeed_unread_filter_changed',
  NEWSFEED_POST_OPENED = 'newsfeed_post_opened',
  NEWSFEED_TRANSLATION_TOGGLED = 'newsfeed_translation_toggled',
  NEWSFEED_POST_LIKED = 'newsfeed_post_liked',
  NEWSFEED_POST_UNLIKED = 'newsfeed_post_unliked',
  NEWSFEED_POST_COMMENTED = 'newsfeed_post_commented',
  NEWSFEED_POLL_ANSWERED = 'newsfeed_poll_answered',
  NEWSFEED_MUST_READ_CREATED = 'newsfeed_must_read_created',
  NEWSFEED_POST_CONFIRMED = 'newsfeed_post_confirmed',
  NEWSFEED_CONFIRMATION_REMINDER_SENT = 'newsfeed_confirmation_reminder_sent',

  // Calendar events
  CALENDAR_ARRIVED = 'calendar_arrived',
  CALENDAR_VIEW_CHANGED = 'calendar_view_changed',
  CALENDAR_WEEK_CHANGED = 'calendar_week_changed',
  CALENDAR_MONTH_CHANGED = 'calendar_month_changed',
  CALENDAR_DAY_SELECTED = 'calendar_day_selected',
  CALENDAR_TASK_CHECKED = 'calendar_task_checked',
  CALENDAR_TASK_UNCHECKED = 'calendar_task_unchecked',

  // Profile events
  PROFILE_NAME_CHANGED = 'profile_name_changed',
  PROFILE_ASSISTANT_NAME_CHANGED = 'profile_assistant_name_changed',
  PROFILE_COMMUNICATION_STYLE_CHANGED = 'profile_communication_style_changed',
  PROFILE_LANGUAGE_CHANGED = 'profile_language_changed',
  PROFILE_SCHEDULE_CHANGED = 'profile_schedule_changed',
  PROFILE_UNDO_TAPPED = 'profile_undo_tapped',

  // Recording events (the capture flow, before the analysis decides the outcome)
  RECORDING_STARTED = 'recording_started',
  RECORDING_SWITCHED_TO_DICTATION = 'recording_switched_to_dictation',
  RECORDING_SWITCHED_TO_TYPING = 'recording_switched_to_typing',
  RECORDING_CANCELLED = 'recording_cancelled',
  RECORDING_SUBMITTED = 'recording_submitted',

  // Note events
  NOTE_DELETED = 'note_deleted',

  // Store events
  STORE_EVENTS_ARRIVED = 'store_events_arrived',
  STORE_EVENTS_FILTER_CHANGED = 'store_events_filter_changed',
  STORE_EVENTS_REFRESHED = 'store_events_refreshed',
  STORE_EVENTS_ADD_LOCATION_OPENED = 'store_events_add_location_opened',
  STORE_EVENTS_CATEGORY_TOGGLED = 'store_events_category_toggled',
  STORE_EVENT_OPENED = 'store_event_opened',
  STORE_EVENT_ACCEPTED = 'store_event_accepted',
  STORE_EVENT_DISMISSED = 'store_event_dismissed',
  STORE_EVENT_LINK_OPENED = 'store_event_link_opened',

  // Onboarding events
  ONBOARDING_STARTED = 'onboarding_started',
  ONBOARDING_LANGUAGE_SELECTED = 'onboarding_language_selected',
  ONBOARDING_PREFERRED_NAME_PROVIDED = 'onboarding_preferred_name_provided',
  ONBOARDING_APP_SETTINGS_PROVIDED = 'onboarding_app_settings_provided',
  ONBOARDING_MICROPHONE_GRANTED = 'onboarding_microphone_granted',
  ONBOARDING_MICROPHONE_SKIPPED = 'onboarding_microphone_skipped',
  ONBOARDING_MICROPHONE_DENIED = 'onboarding_microphone_denied',
  ONBOARDING_COMPLETED = 'onboarding_completed',
}
